var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a',{attrs:{"href":"http://www.ilabafrica.ac.ke/"}},[(_setup.countyIsKilifi)?_c('v-img',_vm._b({attrs:{"src":require("@/assets/images/ilab-logo.png")}},'v-img',_vm.$attrs,false)):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }